import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 секунд - данные считаются свежими
      gcTime: 1000 * 60 * 30, // 30 минут - время хранения в кеше (было cacheTime)
      refetchOnWindowFocus: false, // Не обновлять при фокусе - используем интервалы
      refetchOnMount: false, // Не обновлять при монтировании, если данные есть в кеше
      refetchOnReconnect: true, // Обновлять при восстановлении соединения
      retry: 1, // Количество повторных попыток при ошибке
    },
    mutations: {
      retry: 1,
    },
  },
});
